$(document).on('click', '.machine-types__nav-tablinks', function(event) {

  const {count} = event.currentTarget.dataset;
  let i, tabcontent = document.getElementsByClassName('machine-types__content');
  for(i = 0; i < tabcontent.length; i++){
    tabcontent[i].computedStyleMap.display = 'none';
  }
  let tablinks = document.getElementsByClassName('machine-types__nav-tablinks');
  for(i = 0; i < tablinks.length; i++){
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  $(`.machine-types__content`).css('display',"none");
  $(`#machine-types__tab-${count}`).css('display',"block");
  event.currentTarget.className += " active";
})
